import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { useWishlist } from "@/context/WishlistContext";
import { useCart } from "@/context/CartContext";
import { ProductCard } from "@/components/ProductCard";
import { Seo } from "@/components/Seo";

export default function Wishlist() {
  const { items } = useWishlist();
  const { addItem } = useCart();

  return (
    <div data-testid="wishlist-page" className="max-w-[1400px] mx-auto px-5 sm:px-8 py-10 min-h-[60vh]">
      <Seo title="Your Wishlist" description="Your saved Indian ethnic wear pieces at Kurti Connection USA." path="/wishlist" noindex />
      <div className="text-center mb-10">
        <div className="overline text-[#6E6E69]">Kurti Connection USA</div>
        <h1 className="font-display text-5xl sm:text-6xl tracking-tight mt-1">Your Wishlist</h1>
        <p className="text-sm text-[#6E6E69] mt-2">{items.length} {items.length === 1 ? "piece saved" : "pieces saved"}</p>
      </div>

      {items.length === 0 ? (
        <div className="text-center py-24 flex flex-col items-center gap-4">
          <Heart size={40} strokeWidth={1.2} className="text-[#B84A3B]" />
          <p className="font-display text-3xl text-[#6E6E69]">No favourites yet</p>
          <p className="text-sm text-[#6E6E69] max-w-sm">Tap the heart on any piece you love and it'll wait for you here.</p>
          <Link to="/shop" data-testid="wishlist-shop-link" className="overline border-b border-[#1A1A1A] pb-1 mt-2 hover:text-[#B84A3B] transition-colors">Start Shopping</Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-x-4 gap-y-10">
          {items.map((p, i) => (
            <ProductCard key={p.slug} product={p} index={i} onAdd={(pr, s) => addItem(pr, s)} />
          ))}
        </div>
      )}
    </div>
  );
}
